import { render, staticRenderFns } from "./VesselReport.vue?vue&type=template&id=3b724842"
import script from "./VesselReport.vue?vue&type=script&lang=js"
export * from "./VesselReport.vue?vue&type=script&lang=js"
import style0 from "./VesselReport.vue?vue&type=style&index=0&id=3b724842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports